import { loadingProjectsFailed } from 'owa-timestream-store';
import { DefaultBoardCreationState } from '../schema';
import getDefaultBoardCreationState from './getDefaultBoardCreationState';

/**
 * Checks whether there were failures around creating/deleting/loading the default calendar board project.
 * NOTE: for now, this is a variation on the Project Moca selector with additional handling for board concerns
 * @returns true if there was an issue, false otherwise
 */
export default function didLoadingCalendarBoardProjectFail(): boolean {
    const projectCreationState = getDefaultBoardCreationState();
    return (
        projectCreationState === DefaultBoardCreationState.ErrorCreateNew || loadingProjectsFailed()
    );
}
